import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MultiLanguageService } from '../services/multi-language.service';

@Pipe({
  name: 'translate',
  pure: false,
})
export class TranslatePipe implements PipeTransform {
  constructor(
    private readonly translate: TranslateService,
    private readonly _multiLanguageService: MultiLanguageService,
    private readonly cdr: ChangeDetectorRef
  ) {
    this._multiLanguageService.currentLanguage$.subscribe((lang) => {
      this.translate.use(lang).subscribe({
        next: () => {
          // Language file loaded successfully
          this.cdr.markForCheck();
        },
        error: (err) => {
          // Handle the case where the JSON file is not available
          console.error(`Failed to load language file for: ${lang}`, err);
          // Optionally, set a fallback language or notify the user
          this.translate.use('en').subscribe(() => {
            this.cdr.markForCheck();
          });
        },
      });
    });
  }

  transform(value: string): string {
    if (!value) return '';
    let translated = this.translate.instant(value);
    return translated ?? value;
  }
}
